// Some properties are images and need to be downloaded

import { downloadImageAsBase64 } from '../images/downloadImageAsBase64';

const elementsAndProperties = [{ element: 'video', property: 'poster' }];

export const downloadPropertiesAsBase64 = async (node: HTMLElement) => {
  for (const { element, property } of elementsAndProperties) {
    const elements = node.querySelectorAll(element);
    for (const el of elements) {
      const propertyValue = el.getAttribute(property);
      if (propertyValue) {
        const base64 = await downloadImageAsBase64(propertyValue);

        el.setAttribute(property, base64);
      }
    }
  }
};
